import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { HorizontalScrollRow } from '@/ui/common';
import { LiveEventChip, type LiveEventChipProps } from './LiveEventChip';

export interface LiveEventsRailItem extends Omit<LiveEventChipProps, 'onSelect'> {
  eventId: number;
}

export interface LiveEventsRailProps {
  events: LiveEventsRailItem[];
  selectedEventId?: number;
  onSelectEvent?: (eventId: number) => void;
  className?: string;
}

export function LiveEventsRail({
  events,
  selectedEventId,
  onSelectEvent,
  className,
}: LiveEventsRailProps) {
  const { t } = useTranslation();
  if (events.length === 0) return null;

  return (
    <div className={cn('-mx-4 min-w-0 px-4 lg:mx-0 lg:px-0', className)}>
      <HorizontalScrollRow
        aria-label={t('LiveEvents', { defaultValue: 'Live events' })}
        withDesktopArrows
        className="gap-2 pl-0"
      >
        {events.map((event) => (
          <LiveEventChip
            key={event.eventId}
            home={event.home}
            away={event.away}
            homeScore={event.homeScore}
            awayScore={event.awayScore}
            clock={event.clock}
            liveClockState={event.liveClockState}
            translatePeriod={event.translatePeriod}
            hasLiveStream={event.hasLiveStream}
            selected={event.eventId === selectedEventId}
            onSelect={onSelectEvent ? () => onSelectEvent(event.eventId) : undefined}
          />
        ))}
      </HorizontalScrollRow>
    </div>
  );
}
